<template>
  <div class="select-equity-container">
    <el-dialog
      class="select-equity--dialog"
      title="选择权益"
      :visible="isShow"
      width="1000px"
      @close="onClose"
    >
      <div class="form-box">
    <el-form
      ref="formSearch"
      class="formClass"
      :inline="true"
      :model="formData"
      label-width="150px"
    >
      <el-form-item label="权益名称:">
        <el-input
          size="small"
          v-model="formData.name"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="最后修改时间:">
        <div class="my_select_time">
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formData.sendStartTimeStart"
            type="datetime"
            :placeholder="'选择日期时间'"
            size="small"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 120px; font-size: 12px"
            class="time1"
            :clearable="false"
          ></el-date-picker>
          <div class="time_to_text">至</div>
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formData.sendStartTimeEnd"
            type="datetime"
            :placeholder="'选择日期时间'"
            size="small"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 145px; font-size: 12px"
            class="time2"
            :clearable="true"
          ></el-date-picker>
          <i
            class="el-icon-circle-close date_icon1"
            @click="clearTimeSendTime()"
          ></i>
          <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
        </div>
      </el-form-item>
      <el-form-item>
        <div
          style="text-align: center; display: inline-block; margin-left: 82px"
        >
          <el-button
            size="small"
            :disabled="tableLoding"
            class="search"
            type="primary"
            @click="getTableList"
          >
            查询
          </el-button>
          <el-button size="small" class="reset" @click="resetForm"
            >重置</el-button
          >
        </div>
      </el-form-item>
    </el-form>
        <div style="text-align: right">
          <el-button type="text" @click="toAddEquity"
            >去添加权益></el-button
          >
        </div>
        <div class="table-box">
          <el-table
            ref="tableRef"
            :data="tableData"
            :header-cell-style="{
              background: '#fafafa',
            }"
            @select="handleSelectionChange"
            @select-all="selectAllChange"
            v-loading="tableLoading"
          >
            <el-table-column
              type="selection"
              :selectable="isRowSelectable"
              width="55"
            ></el-table-column>
            <el-table-column
              prop="benefitEnableIconUrl"
              label="权益图标"
              min-width="100"
              align="center"
            >
              <template slot-scope="scope">
                <img
                  v-if="scope.row.benefitEnableIconUrl"
                  style="width: 50px; height: 50px"
                  :src="scope.row.benefitEnableIconUrl"
                  alt=""
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="权益名称"
              min-width="150"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="jumpInfo"
              label="跳转链接"
              min-width="200"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.jumpInfo || "-" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="updateTime"
              label="最后修改时间"
              min-width="150"
              align="center"
            >
            </el-table-column>
          </el-table>

          <div style="margin-top: 20px" class="new-pagination-page">
            <el-pagination
              style="text-align: right"
              :currentPage="pageInfo.current"
              :page-size="pageInfo.size"
              :page-sizes="[10, 30, 50, 100, 1000]"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">取 消</el-button>
        <el-button @click="comfirm" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import myForm from "@/components/Form/index.vue";
// import { getMemberBenefitInfo } from "@/api/hdApi/children/level";
import {
    getMemberBenefitInfo,
} from "@/api/integralCenter/level";
/**
 * 选择权益
 */
export default {
  name: "SelectCoupon",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    /**小程序id */
    miniappAutoId: {
      type: [String, Number],
      default: "",
    },
    selectedList: {
      // 已选中的权益列表
      type: Array,
      default: () => [],
    },
    maxCount: {
      // 最大选择数量
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      tableLoding:false,
      searchFormData: {
        name: "",
        updateStartTime: "",
        updateEndTime: "",
      },
      myFormInfo: [
        {
          label: "权益名称：",
          prop: "name",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "最后修改时间：",
          prop: "updateTime",
          type: "DateRange",
          dateType: "datetime",
          startKey: "updateStartTime",
          endKey: "updateEndTime",
        },
      ],
      pageInfo: {
        current: 1,
        size: 10,
      },
      total: 0,
      tableLoading: false,
      tableData: [],
      selectedRows: [],
      formData: {
        name: "", //活动主题
        concent: "", //短信内容
        orderRemark: "", //活动类型
        activityType: "",
        orderstatus: "", //发送状态
        orderStartTimeStart: "", //提交时间开始
        orderStartTimeEnd: "", //提交时间结束
        sendStartTimeStart: "", //发送时间开始
        sendStartTimeEnd: "", //发送时间结束
        monile: "",
      },
    };
  },
  watch: {
    // resetForm() {
    //   this.formData = {
    //     pin: "",
    //     fullName: "",
    //     mobile: "",
    //     orderId: "",
    //     waybill: "",
    //     orderPaymentStart: "",
    //     orderPaymentEnd: "",
    //     orderStartTimeStart: "",
    //     orderStartTimeEnd: "",
    //     orderState: "",
    //     deliveryType: "",
    //     wareIds: "",
    //     orderSource: "",
    //     orderRemark: "",
    //     orderRemarkContent: "",
    //     skuName: "",
    //     skuName: "",
    //     skuName: "",
    //     orderstatus: "",
    //   };
    //   this.$emit("onSerach", this.formData);
    // },
    isShow(val) {
      if (val) {
        this.selectedRows = this.selectedList;
        this.pageInfo.current = 1;
        this.getTableList();
      }
    },
  },
  created() {
    this.selectedRows = this.selectedList;
    this.pageInfo.current = 1;
    this.getTableList();
  },
  methods: {
    resetForm() {
      this.formData = {
        name: "", //活动主题
        concent: "", //短信内容
        orderRemark: "", //活动类型
        activityType: "",
        orderstatus: "", //发送状态
        orderStartTimeStart: "", //提交时间开始
        orderStartTimeEnd: "", //提交时间结束
        sendStartTimeStart: "", //发送时间开始
        sendStartTimeEnd: "", //发送时间结束
        monile: "",
      };
      this.getTableList()
    },
    //列表查询
    async getTableList() {
      let params = {
        ...this.formData,
        current: this.pageInfo.current,
        size: this.pageInfo.size,
      };
      this.tableLoading = true;
      try {
        const res = await getMemberBenefitInfo(params);
        this.tableLoading = false;
        if (res.code == 1) {
          let list = res.data.records || [];
          this.tableData = list;

          console.log("this.tableData>>", this.tableData);
          this.total = res.data.total;
          this.$nextTick(() => {
            this.setInitialSelection();
          });
        }
      } catch (err) {
        this.tableLoading = false;
      }
    },
    //查询
    recordQuery(form) {
      this.searchFormData = form;
      this.pageInfo = {
        current: 1,
        size: 10,
      };
      this.getTableList();
    },

    isRowSelectable(row) {
      return (
        this.selectedRows.length < this.maxCount ||
        this.selectedRows.some((item) => item.id == row.id)
      );
    },
    handleSearch() {
      this.$refs.myFormRef.handleSearch();
    },
    handleReset() {
      this.$refs.myFormRef.handleReset();
    },
    comfirm() {
      this.$emit("input", false); // 关闭弹窗
      this.$emit("select", this.selectedRows); // 传递选中的权益列表
    },
    setInitialSelection() {
      // 清空当前选中
      this.$refs.tableRef.clearSelection();
      // 遍历已选中的行，设置选中状态
      this.selectedRows.forEach((row) => {
        const foundRow = this.tableData.find((item) => item.id == row.id);
        if (foundRow) {
          this.$refs.tableRef.toggleRowSelection(foundRow);
        }
      });
    },
    // 全选/取消全选
    selectAllChange(selectedRows) {
      let selectedMarkList = this.selectedRows.map((item) => item.id);
      // 当前页选中行的标记列表
      let pageSelectedMarkList = Array.isArray(selectedRows)
        ? selectedRows.map((item) => item.id)
        : [];

      this.tableData.forEach((row) => {
        if (pageSelectedMarkList.includes(row.id)) {
          if (!selectedMarkList.includes(row.id)) {
            this.addItem(row);
          }
        } else if (selectedMarkList.includes(row.id)) {
          this.removeItem(row);
        }
      });

      if (this.selectedRows.length > this.maxCount) {
        this.$message.warning(`最多选择${this.maxCount}个权益`);
        // 取消多余的选择项
        const excessSelections = this.selectedRows.slice(this.maxCount);
        this.selectedRows = this.selectedRows.slice(0, this.maxCount);
        excessSelections.forEach((item) => {
          this.$refs.tableRef.toggleRowSelection(item, false);
        });
        return;
      }
    },
    handleSelectionChange(selectedRows, row) {
      // 更新已选中的行
      let selected = selectedRows.length && selectedRows.indexOf(row) !== -1;
      if (selected) {
        this.addItem(row);
      } else {
        this.removeItem(row);
      }
    },
    // 移除选中项
    removeItem(item) {
      for (let [index, itemTemp] of this.selectedRows.entries()) {
        if (itemTemp.id === item.id) {
          this.removeItemByIndex(index);
          break;
        }
      }
    },
    removeItemByIndex(index, item) {
      this.selectedRows.splice(index, 1);

      // 若有item,则是点击标签上的关闭按钮，移除选中项
      if (item) {
        this.$nextTick(() => {
          this.$refs.tableRef.toggleRowSelection(
            // 此处必须在 tableData 中查找对应的数据，否则 toggleRowSelection 会失效
            this.tableData.find((row) => {
              return row.id === item.id;
            }),
            false
          );
        });
      }
    },
    addItem(item) {
      this.selectedRows.push(item);
    },
    // 新增：用于外部设置初始选中项
    setSelectedRows(rows) {
      this.selectedRows = rows;
    },
    handleCurrentChange(val) {
      this.pageInfo.current = val;
      this.getTableList();
    },
    handleSizeChange(val) {
      this.pageInfo.current = 1;
      this.pageInfo.size = val;
      this.getTableList();
    },
    onClose() {
      this.$emit("input", false);
      this.$emit("select", this.selectedList);
    },

    toAddEquity() {
     this.$router.push({
        path: "/integralCenter/mutualMember/levelPrivilege",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  padding: 20px 24px !important;
}

.w320 {
  width: 320px;
}

.mgl_8 {
  margin-left: 8px;
}

.select-equity--dialog {
  .btn-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .table-box {
    margin-top: 16px;
  }
}
</style>
